(function () {
  'use strict';
  var measurementId = 'G-M8T1RSE2Z0';
  if (window.__xofyingGA4Bootstrapped) return;
  window.__xofyingGA4Bootstrapped = true;
  var installed = false;
  function updateAnalytics() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    var allowed = privacy.analyticsProcessingAllowed();
    if (installed) {
      window.gtag('consent', 'update', { analytics_storage: allowed ? 'granted' : 'denied' });
      return;
    }
    if (!allowed) return;
    if (document.querySelector('script[src*="googletagmanager.com/gtag/js"][src*="' + measurementId + '"]')) return;
    installed = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { allow_google_signals: false, allow_ad_personalization_signals: false });
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
    document.head.appendChild(script);
  }
  function requestPrivacy() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      document.addEventListener('visitorConsentCollected', updateAnalytics);
      updateAnalytics();
    });
  }
  if (window.Shopify && window.Shopify.loadFeatures) requestPrivacy();
  else window.addEventListener('load', requestPrivacy, { once: true });
})();


